import { FC } from 'react';
import { EstimateCrownIcon, SubscriptionPopper } from 'assets/icons';
import { CustomButton, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { VoidFn } from 'types/baseTypes';

interface SubscribedModalProps {
  onClose: VoidFn;
  title: string | React.ReactNode;
  description: string | React.ReactNode;
  primaryButtonText: string;
  primaryButtonClick: VoidFn;
  secondaryButtonText?: string;
  secondaryButtonClick?: VoidFn;
  icon?: React.ReactNode;
}

const SubscribedModal: FC<SubscribedModalProps> = ({
  onClose,
  title,
  description,
  primaryButtonText,
  primaryButtonClick,
  secondaryButtonText,
  secondaryButtonClick,
  icon
}) => {
  return (
    <CustomModal open={true} width="md:w-[489px]">
      <>
        <SubscriptionPopper />
        <div className="mx-auto -mt-9 mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-secondaryBtn">
          {icon || <EstimateCrownIcon />}
        </div>
        <div className="mb-3 text-center text-2xl font-bold text-heading">{title}</div>
        <div className="mb-6 text-center text-17px text-accentText">{description}</div>
        <div className="m-4">
          <CustomButton
            id="create-new-estimate-button"
            type={ButtonType.PRIMARY}
            onClick={primaryButtonClick}
            className="h-12 w-full">
            {primaryButtonText}
          </CustomButton>
        </div>
        <div className="m-4 mb-6">
          <CustomButton
            className="h-12 w-full"
            type={ButtonType.SECONDARY}
            id="create-new-estimate-cancel"
            onClick={secondaryButtonClick || onClose}>
            {secondaryButtonText || 'Cancel'}
          </CustomButton>
        </div>
      </>
    </CustomModal>
  );
};

export default SubscribedModal;
